export const getProcessosAgrupadosSelector = state =>
  state?.processosAgrupados?.processosAgrupados || [];
